/**
 * @deprecated use same function from '@rchh/lowcode-utils' instead
 */
export function isJSFunction(x) {
  return typeof x === 'object' && x && x.type === 'JSFunction';
}